if (!customElements.get('tailor-pack')) {
  customElements.define(
    'tailor-pack',
    class TailorPack extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.onChange = (event) => {
          const target = event.target;
          if (target.closest('tailor-pack') || target.classList?.contains('quantity__input')) {
            this.sync();
          }
        };
        this.productInfo?.addEventListener('change', this.onChange);
        this.onCoffeeCapture = (event) => {
          const input = event.target;
          if (!input.classList?.contains('tailor-stock__input')) return;
          const allowed = new Set((input.dataset.batches || '').split('|').filter(Boolean));
          const batches = input.closest('variant-selects')?.querySelectorAll('.tailor-batch__input');
          if (!batches?.length || !allowed.size) return;
          const current = [...batches].find((el) => el.checked);
          if (current && allowed.has(current.value)) return;
          const next = [...batches].find((el) => allowed.has(el.value) && !el.classList.contains('disabled'))
            || [...batches].find((el) => allowed.has(el.value));
          if (next) next.checked = true;
        };
        this.productInfo?.addEventListener('change', this.onCoffeeCapture, true);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubQty = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.sync());
        }
        requestAnimationFrame(() => this.sync());
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
        this.productInfo?.removeEventListener('change', this.onCoffeeCapture, true);
        this.unsubQty?.();
      }

      packing(qty, style) {
        const unit = this.dataset.unit || '60';
        const combined = this.dataset.combined || '120';
        if (style !== this.dataset.combineValue) {
          return `${qty} 包 ${unit}g`;
        }
        const big = Math.floor(qty / 2);
        const rem = qty % 2;
        const parts = [];
        if (big) parts.push(`${big} 包 ${combined}g`);
        if (rem) parts.push(`${rem} 包 ${unit}g`);
        return parts.join(' + ') || `1 包 ${unit}g`;
      }

      sync() {
        const qtyInput = this.productInfo?.querySelector('.quantity__input');
        const parsed = parseInt(qtyInput?.value, 10);
        const qty = Number.isNaN(parsed) ? 1 : Math.max(1, parsed);
        const selected = this.querySelector('[data-tailor-pack]:checked');
        const summary = this.productInfo?.querySelector('[data-tailor-pack-summary]');
        const resultInput = this.querySelector('[data-tailor-pack-result]');
        if (!selected) {
          if (summary) summary.textContent = this.dataset.prompt || '';
          if (resultInput) resultInput.value = '';
          return;
        }
        const result = this.packing(qty, selected.value);
        if (summary) {
          const prefix = this.dataset.summaryPrefix || '將以';
          const suffix = this.dataset.summarySuffix || '寄出';
          summary.textContent = `${prefix} ${result} ${suffix}`;
        }
        if (resultInput) resultInput.value = result;
      }
    }
  );
}
